import { Box, Container, Grid, Typography } from '@mui/material';
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { API_URL, APP_URL } from '../../Config';
import client90 from "../../images/hero-art.jpg";

const New_details = () => {
    const params = useParams();
    const [news, setnewsdata] = useState("");

    const fetchnews = async () => {
        await axios.get(`${API_URL}/indexData.php?type=fetchnewsbyid&id=${params.id}`, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }).then((res) => {
            setnewsdata(res.data);

        })

    }

    useEffect(() => {
        fetchnews();
    }, [])

    return (
        <>
            <Box className='createcollection_bg'>
                <Typography variant='h2' fontWeight='600' fontSize='45px'>
                    New Details
                </Typography>
            </Box>

            <Box >
                <Container maxWidth='xl'>
                    <Grid container spacing={1}>
                        <Grid item lg={8} sm={12} md={12} xs={12} margin='0 auto'>
                            <Box className='new_details'>
                                <img src={news[0] ? APP_URL + '/' + news[0].image : ""} width='100%' className='main_ph' />
                                <Typography variant='h3' fontSize='26px' marginY='10px' fontWeight='600'>{news[0] ? news[0].title : ""}</Typography>
                                <Typography variant='h6' fontSize='15px' marginY='10px' fontWeight='300'>{news[0] ? news[0].time : ""}</Typography>
                                <Typography variant='h6' fontSize="18px" lineHeight='26px' paddingTop='10px'>
                                    {news[0] ? news[0].description : ""}
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </Box> 
        </>
    )
}

export default New_details;